import { Box, HStack, Text, WhiteCard } from '@elkaso-app/web-design';
import { ProcessingStatusBadge } from './table-cells/processing-status-badge';
import { ValidationStatusBadge } from './table-cells/validation-status-badge';

interface StatusCardsProps {
  processingStatus: string;
  validationStatus: string;
}

export const StatusCards = ({ processingStatus, validationStatus }: StatusCardsProps) => {
  return (
    <WhiteCard p='lg'>
      <HStack spacing='xl'>
        <Box>
          <Text fontSize='xs' color='gray.500' mb='xs'>
            Processing Status
          </Text>
          <ProcessingStatusBadge status={processingStatus} />
        </Box>
        <Box>
          <Text fontSize='xs' color='gray.500' mb='xs'>
            Validation Status
          </Text>
          <ValidationStatusBadge status={validationStatus} />
        </Box>
      </HStack>
    </WhiteCard>
  );
};
